import { z } from 'zod'

export const loginSchema = z.object({
  email: z.string().min(1, 'Oops! Incorrect Mail Id. Please try again.').email('Oops! Incorrect Mail Id. Please try again.'),
  password: z.string().min(1, 'Oops! Incorrect Password Please try again.'),
  orgCode: z.string().optional(),
  rememberMe: z.boolean(),
})

export type LoginFormData = z.infer<typeof loginSchema>

export const otpSchema = z.object({
  otp: z.string().length(4, 'OTP must be 4 digits'),
})

export type OtpFormData = z.infer<typeof otpSchema>

export const forgotPasswordSchema = z.object({
  contactValue: z.string()
    .trim()
    .min(1, 'Please enter your email address or mobile number.')
    .refine((val) => {
      if (!val) return false
      const isEmail = val.includes('@')
      if (isEmail) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)
      }
      const normalizedPhone = val.replace(/[^\d]/g, '')
      return /^\d{10,15}$/.test(normalizedPhone)
    }, {
      message: 'Please enter a valid email address or mobile number.'
    }),
  orgCode: z.string().optional(),
})

export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>

export const resetPasswordSchema = z.object({
  newPassword: z.string()
    .min(1, 'Please enter the new password.')
    .refine((val) => /^(?=.*[A-Z]).{8,}$/.test(val), {
      message: 'Password must be at least 8 characters with an uppercase letter.',
    }),
  confirmPassword: z.string()
    .min(1, 'Please confirm the new password.'),
}).refine((data) => data.newPassword === data.confirmPassword, {
  message: 'Confirm Password does not match your New Password.',
  path: ['confirmPassword'],
})

export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>
